import { getDataSource } from '@rsos/components/capstone/Location/helpers';
import { Box, Text } from '@rsos/components/capstone/base';
import getCallStatusName from '@rsos/utils/getCallStatusName';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';
import {
  CallStatus,
  CallStatusTag,
} from '../../../../Queue/EmergencyCall/EmergencyCall.styles';

/**
 * Component for rendering call data in a popup. Currently only used for Esri
 * @param {Object} popupData
 * @param {Object} popupData.callData - callQueue[callerID].core.locations[idx] data
 * @param {String} popupData.callStatus - callQueue[callerID].callStatuses data
 */
const CallPopup = ({ isAllView, popupData }) => {
  const callerID = popupData.callData.caller_id;

  const formattedCallerID = formatInternationalPhoneNumberHuman(callerID);

  const source = getDataSource(popupData.callData);

  const callStatus = popupData.callStatus;

  const callStatusDisplayName = getCallStatusName(callStatus);

  return (
    <Box>
      <Text marginBottom="5px" size="large" fontWeight="bold">
        {formattedCallerID}
      </Text>
      <Text marginBottom="5px" size="large">
        {convertUnixTimestamp(Number(popupData.callData.call_start_time), true)}
      </Text>
      {callStatusDisplayName && (
        <CallStatusTag status={callStatus} isCallPopup={true}>
          <CallStatus data-name="call-status" status={callStatus}>
            {callStatusDisplayName}
          </CallStatus>
        </CallStatusTag>
      )}
      {!isAllView && <Text size="small">Source: {source}</Text>}
    </Box>
  );
};

export default CallPopup;
